import axiosWithAuth from '../../helpers/AxiosHelper';
import errorMessage from '../../helpers/errorMessage';
import React from 'react';

// Pieces shared by the Platform Activity pages (backend/api/activity.js).

export const STATE_META = {
    success: { label: 'Succeeded', variant: 'ex-status-success' },
    failed: { label: 'Failed', variant: 'ex-status-danger' },
    stuck: { label: 'Stuck', variant: 'ex-status-warning' },
    running: { label: 'In progress', variant: 'ex-status-info' },
    mapped: { label: 'Mapped', variant: 'ex-status-info' },
    unknown: { label: 'Unknown', variant: '' },
};

export const StatePill = ({ state }) => {
    const meta = STATE_META[state] || STATE_META.unknown;
    return <span className={`ex-status ${meta.variant}`.trim()}>{meta.label}</span>;
};

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '—');

export function fmtAgo(iso) {
    if (!iso) return '—';
    const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
    if (s < 60) return 'just now';
    const m = Math.round(s / 60);
    if (m < 60) return `${m} min ago`;
    const h = Math.round(m / 60);
    if (h < 48) return `${h} h ago`;
    return `${Math.round(h / 24)} days ago`;
}

export function fmtDuration(ms) {
    if (ms == null) return '—';
    if (ms < 1000) return `${ms} ms`;
    const s = ms / 1000;
    if (s < 90) return `${s.toFixed(1)} s`;
    const m = s / 60;
    return m < 90 ? `${m.toFixed(1)} min` : `${(m / 60).toFixed(1)} h`;
}

export const errMsg = (err) => errorMessage(err);

export const WINDOWS = [
    { label: 'Last 24 hours', value: 1 },
    { label: 'Last 7 days', value: 7 },
    { label: 'Last 30 days', value: 30 },
    { label: 'Last 90 days', value: 90 },
];

// GET with a per-tab cache (sessionStorage, survives a page reload, gone when
// the tab closes) so revisiting a platform, switching tabs or reloading does
// not refetch - the Refresh buttons pass force. Resolves like axios ({ data }).
const CACHE_PREFIX = 'activity-cache:';
const DEFAULT_TTL_MS = 10 * 60 * 1000;

export function cachedGet(url, { params, force = false, ttlMs = DEFAULT_TTL_MS } = {}) {
    const key = CACHE_PREFIX + url + (params ? `?${new URLSearchParams(params).toString()}` : '');
    if (!force) {
        try {
            const hit = JSON.parse(sessionStorage.getItem(key) || 'null');
            if (hit && Date.now() - hit.at < ttlMs) return Promise.resolve({ data: hit.data, cached_at: hit.at });
        } catch { /* storage unavailable or corrupt - fetch */ }
    }
    return axiosWithAuth.get(url, { params: { ...params, ...(force ? { fresh: 1 } : {}) } }).then((res) => {
        try {
            sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data: res.data }));
        } catch {
            // Full: drop this page's older entries and carry on uncached.
            try { Object.keys(sessionStorage).filter((k) => k.startsWith(CACHE_PREFIX)).forEach((k) => sessionStorage.removeItem(k)); } catch { /* ignore */ }
        }
        return res;
    });
}
